/**
 * Created by Maga on 31.05.2018.
 */
export enum SettingENUM {
  CLIENT_ID = 'esuvo',
  ENROLL_CLIENT_ID = 'enroll',
  CLIENT_SECRET = 'AstanaCity',
  API_USER = 'user',
  TOKEN_STR = 'esuvo_token',
  REGION_ID = 'region_id',
  MENU_MAX_SECTIONS_COUNT = 6,
  MENU_MAX_SUBSECTIONS_COUNT = 10,
  MENU_MAX_TREE_DEPTH = 3
}



// WEBPACK FOOTER //
// ./src/app/common/enums/setting.enum.ts